import { useEffect } from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'
// import { useAuth } from '../hooks/useAuth'
import { useLazyQuery, gql, useReactiveVar } from '@apollo/client'

import { EditableComponent } from '../components'
import { apolloAuthData, getEditStatus } from '../services/apollo'
import { ROLE_MANAGER } from '../constants'
import { ReactComponent as Curve4 } from '../assets/images/curve-4.svg'

const GET_HOME_HERO = gql`
  query HomePages {
    homePages(first: 1) {
      edges {
        node {
          databaseId
          subtitle
          title
          overview
        }
      }
    }
  }
`

const HomeHero = () => {
  const auth = useReactiveVar(apolloAuthData)
  const isManager = auth.user?.capabilities?.includes(ROLE_MANAGER)
  const [getHomeHero, { loading, error, data }] = useLazyQuery(GET_HOME_HERO, {
    fetchPolicy: 'no-cache',
  })
  let [searchParams] = useSearchParams()
  const isEditOn = isManager && !!searchParams.get('edit')
  const homePageData = data?.homePages?.edges[0]?.node ?? null

  useEffect(() => {
    if (!isEditOn && getEditStatus().changes.length === 0) {
      getHomeHero()
    }
  }, [isEditOn, getHomeHero])

  // Load data every time the page is loaded with edit mode on
  useEffect(() => {
    if (isEditOn) {
      getHomeHero()
    }
  }, [isEditOn, getHomeHero])

  return (
    <div className="relative flex h-[100vh] items-center justify-center bg-ateneo-blue pb-36 pt-24 text-white medium:pb-0 medium:pt-0 short:h-[200vh] short:items-start">
      <div className="absolute top-0 h-full w-full bg-hero-background bg-cover bg-no-repeat opacity-[10%]"></div>
      <div className="absolute bottom-0 w-full">
        <Curve4 className="relative [&_path]:!fill-lotion" />
      </div>
      <div className="z-10 px-4 medium:pt-[90px]">
        {loading || !data ? (
          <></>
        ) : (
          <>
            <div className="mx-auto lg:w-4/5 xl:w-3/5">
              <div className="text-center text-3xl font-bold leading-[70px] medium:text-2xl medium:leading-[35px]">
                {isEditOn ? (
                  <EditableComponent
                    editable={isEditOn}
                    doc={homePageData?.subtitle ?? '<div></div>'}
                    toolbarOption={{
                      bold: false,
                      listNumber: false,
                      listBullet: false,
                    }}
                    tag={{
                      page: 'HOME_PAGE',
                      type: 'heroSubtitle',
                      databaseId: homePageData?.databaseId,
                      action: 'update',
                    }}
                    disableParagraph={true}
                  />
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: homePageData?.subtitle ?? '<div></div>',
                    }}
                  />
                )}
              </div>
              <div className="mb-12 text-center text-5xl font-bold medium:mb-6 medium:text-3xl">
                {isEditOn ? (
                  <EditableComponent
                    editable={isEditOn}
                    doc={homePageData?.title ?? '<div></div>'}
                    scrollbarY={false}
                    toolbarOption={{
                      bold: false,
                      listNumber: false,
                      listBullet: false,
                    }}
                    tag={{
                      page: 'HOME_PAGE',
                      type: 'heroTitle',
                      databaseId: homePageData?.databaseId,
                      action: 'update',
                    }}
                    disableParagraph={true}
                  />
                ) : (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: homePageData?.title ?? '<div></div>',
                    }}
                  />
                )}
              </div>
            </div>
            <div className="mx-auto w-full md:w-3/5 xl:w-2/5">
              {isEditOn ? (
                <EditableComponent
                  editable={isEditOn}
                  doc={homePageData?.overview ?? '<div></div>'}
                  tag={{
                    page: 'HOME_PAGE',
                    type: 'heroOverview',
                    databaseId: homePageData?.databaseId,
                    action: 'update',
                  }}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: homePageData?.overview ?? '<div></div>',
                  }}
                />
              )}
              {!auth.user && (
                <div className="mt-12 text-center">
                  <NavLink
                    to="register"
                    className="rounded-full bg-skin-button-accent px-8 pb-3 pt-[0.6rem] transition-colors hover:bg-skin-button-accent-hover"
                  >
                    register
                  </NavLink>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default HomeHero
